module.exports = __webpack_public_path__ + "static/media/getFetch.51c934af.cjs";